import { ReactNode } from 'react';

type TransactionBodyEntryProps = {
    title: string;
    value: ReactNode;
};

const TransactionBodyEntry: React.FC<TransactionBodyEntryProps> = ({ title, value }) => {
    return (
        <div className='transaction-body-entry'>
            <div className='title'>{title}</div>
            <div className='value'>{value}</div>
        </div>
    );
};

export default TransactionBodyEntry;
